import { client } from '@hotjar/api-base-client';
import { v4 as generateUUID } from 'uuid';
import type { SubmitSurveyRequestDto, SubmitSurveyResponseDto } from './survey-dto';
import type { SubmitSurveyRequestData, SubmitSurveyResponseData } from './survey-model';

interface Answer {
  question: string;
  questionUuid: string;
  answer: string;
  comment: string | null;
}

export async function submitChurnSurvey(
  pollId: string,
  surveyData: Answer[],
  url: string,
): Promise<SubmitSurveyResponseData> {
  const submitUrl = `/api/v2/client/sites/14/poll/${pollId}/response/${generateUUID()}`;
  const data = await client<
    SubmitSurveyResponseData,
    SubmitSurveyResponseDto,
    SubmitSurveyRequestData,
    SubmitSurveyRequestDto
  >({
    url: submitUrl,
    method: 'POST',
    data: {
      action: 'create_or_update_poll_response',
      responseContent: JSON.stringify({
        answers: surveyData,
        version: 4, // survey response version number
      }),
      url,
    },
  });

  return data;
}
